import React from "react"
import { FieldError, FieldErrorsImpl, Merge } from "react-hook-form";
import { cn } from "@/lib/utils";

interface ShowFormErrorProps {
    message?: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined;
    className?: string;
}

export const ShowFormError: React.FC<ShowFormErrorProps> = ({ message, className }) => {
    if (!message) return null;

    return (
        <p className={cn("mt-1 text-sm text-red-600", className)}>
            {typeof message === 'string' ? message : String(message)}
        </p>
    );
};